import CarouselDisplayTrigger from '../enums/CarouselDisplayTrigger';
import { getAmplitudeInstance } from '../amplitudeHelpers';

type logWebSignUpModalShownParams = {
  trigger?: CarouselDisplayTrigger;
};

/**
 * Fires when an unauthenticated user views the Sign Up Modal on Web (mobile or desktop).
 * @param params - Attributes to log with the amplitude event
 * @param params.trigger - The trigger that caused the web pro modal to display.
 */
const logWebSignUpModalShown = ({ trigger }: logWebSignUpModalShownParams, callback?: () => void) => {
  getAmplitudeInstance().logEvent('web sign up modal shown', { trigger }, callback);
};

export default logWebSignUpModalShown;
